import I18N from '@leverege/i18n';
const {
  tIcon
} = I18N.ns('molten.imagine.DeviceSelector');
export default {
  id: 'molten.DeviceSelector.ClearSearchAction',
  matches: {
    client: 'DeviceSelectorOpened'
  },
  handles: context => {
    const {
      search,
      value
    } = context;
    return !!search || value;
  },
  appearance: () => ({
    icon: tIcon('clear')
  }),
  perform: ({
    context
  }) => {
    const {
      onClear
    } = context;
    onClear();
  }
};